import "../styles/WhatWeDo.css";
import {Badge} from "./Badge";
import * as React from "react";
import {CardDeck} from "./CardDeck";
import {Config} from "../Config";
import {Tool, ToolIcons} from "./Tool";
import {Accordions} from "./Accordions";

export function WhatWeDo() {
    const [active, setActive] = React.useState(1);
    const [cards, setCards] = React.useState([
        {
            id: 1,
            content: <div className={"card-content-wrapper"}>
                <div className="left-side">
                    <h3>Websites & landing pages that convert</h3>
                    <p>
                        Stuck with a visually outdated website that struggles to convey the true value of your
                        products
                        or services?
                    </p>
                    <p>
                        Let us design and build a website that:
                    </p>
                    <ul>
                        <li>Is on-brand, reflecting your unique identity</li>
                        <li>Addresses your audience's wants and needs</li>
                        <li>Is technically sound and provides smooth UX</li>
                    </ul>
                </div>
                <div className="right-side">
                    <img src={process.env.PUBLIC_URL + "/assets/Dribbble_black_friday_2.png"}/>
                </div>
            </div>
        },
        {
            id: 2,
            content: <div className={"card-content-wrapper"}>
            <div className="left-side">
                    <h3>Web & mobile apps
                        with stunning visuals</h3>
                    <p>
                        Are your web and mobile apps lacking the visual impact necessary to communicate your brand essence effectively?
                    </p>
                    <p>
                        We can assist with:
                    </p>
                    <ul>
                        <li>Captivating UI that embodies your identity</li>
                        <li>Establishing unified design systems</li>
                        <li>Improving engagement with intuitive designs</li>
                    </ul>
                </div>
                <div className="right-side">
                    <img src={process.env.PUBLIC_URL + "/assets/Teamio_dribbble.png"} alt={"Full-Stack Development"}/>
                </div>
            </div>
        },
        {
            id: 0,
            content: <div className={"card-content-wrapper"}>
                <div className="left-side">
                    <h3>Visual branding that helps you stand out</h3>
                    <p>
                        Feeling that your inconsistent branding visuals fail to effectively communicate the essence of
                        your brand?
                    </p>
                    <p>
                        We can help you though the following:
                    </p>
                    <ul>
                        <li>Fresh visual identity your audience will love</li>
                        <li>Original graphics and promotional content</li>
                        <li>Photos and videos that will help you stand out</li>
                    </ul>
                </div>
                <div className="right-side">
                    <img src={process.env.PUBLIC_URL + "/assets/Dribbble_black_friday_2.png"}/>
                </div>
            </div>
        }
    ]);

    return <div className="what-we-do section scroll-zoom-out" data-react-on={Config.PageSections.HowItWorks} id={Config.PageSections.Services}>
        <Badge className={"animate-from-bottom"}>What we do</Badge>
        <h2 className={"animate-from-bottom delay-1"}>
            Experts in websites from start to finish.
        </h2>
        <p className="subtitle animate-from-bottom delay-2">
            We focus on UI design, Framer development or custom build, but we’re flexible. Need something else? Just reach out.
        </p>

        <div className={"columns animate-from-bottom delay-3"}>
            <div className={"left-column"}>
                <p className={"font-tag-text"}>Our tool stack</p>

                <Tool icon={ToolIcons.Figma} />
                <Tool icon={ToolIcons.Framer} />
                <Tool icon={ToolIcons.Github} />
                <Tool icon={ToolIcons.Notion} />
                <Tool icon={ToolIcons.Trello} />
                <Tool icon={ToolIcons.Slack} />
            </div>

            <Accordions />
        </div>
    </div>;
}
